export default "__VITE_ASSET__DGDE1ArW__"